import api from './client';

export interface FreeShippingBarTier {
  threshold_cents: number;
  reached_message: string;
}

export interface FreeShippingBarSettings {
  enabled: boolean;
  threshold_cents: number;
  below_threshold_message: string;
  reached_message: string;
  bar_color: string;
  text_color: string;
  position: 'top' | 'bottom';
  corner_radius: number;
  celebration_enabled: boolean;
  additional_tiers: FreeShippingBarTier[];
}

export const freeShippingBarApi = {
  show: () => api.get<{ data: FreeShippingBarSettings }>('/free-shipping-bar'),

  update: (settings: FreeShippingBarSettings) =>
    api.put<{ data: FreeShippingBarSettings }>('/free-shipping-bar', settings),
};
